import './section.scss';
import type { FC, HTMLProps, PropsWithChildren } from 'react';

export const Section: FC<PropsWithChildren<HTMLProps<HTMLDivElement>>> = ({ children, className, ...props }) => {
  return (
    <section className={`section ${className ?? ''}`} {...props}>
      {children}
    </section>
  );
};
